/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GiveawayType = {
    /**
     * Giveaway type ID
     */
    id: string;
    /**
     * 0=DISABLED, 10=ACTIVE
     */
    status: GiveawayType.status;
    /**
     * Admin who created the giveaway
     */
    createdBy?: string | null;
    /**
     * Giveaway name
     */
    name: string;
    /**
     * Frequency in minutes
     */
    frequencyInterval: number;
    /**
     * Required Steam level (0 = no requirement)
     */
    requiredSteamLevel: number;
    /**
     * Required user level (0 = no requirement)
     */
    requiredLevel: number;
    /**
     * Required deposit amount in cents (0 = no requirement)
     */
    requiredDepositAmount: number;
    /**
     * Required deposit within X days (0 = no requirement)
     */
    requiredDepositSinceDays: number;
    /**
     * Whether email verification is required to join
     */
    emailVerifiedRequired: boolean;
    /**
     * Maximum tickets allowed per user
     */
    maxTickets?: number;
    /**
     * Minimum participants to start timer (0 = start immediately)
     */
    minimumParticipants: number;
    /**
     * Soft delete timestamp
     */
    deletedAt?: string | null;
    createdAt?: string;
    updatedAt?: string;
};
export namespace GiveawayType {
    /**
     * 0=DISABLED, 10=ACTIVE
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
    }
}

